/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import { LoginContext } from '../App';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getProfileData } from '../redux/UserSessionSlice';
import { isInlynkGroupMissing } from '../libs/HelperContent';
import CompanyDropdown from '../UiComponents/InlinkLogo/CompanyDropdown';

const EmployeePendingHoc = (WrappedComponent) =>
{
	return function NewComponent()
	{
		const session = useSelector((state:any) => state?.mysession?.session);

		const { socket } = useContext(LoginContext);
		const navigation = useNavigate();
		const dispatch = useDispatch();

		const handleUserNavagation = async () =>
		{
			const isMissing = await isInlynkGroupMissing();

			if (isMissing && [ '/individual-signup', '/employee-signup', '/company-signup' ]?.includes(window.location.pathname))
			{
				navigation(window.location.pathname);
			}
			else if (isMissing)
			{
				navigation('/signup?source=inmeet');
			}
			else if (session?.isActive === 'active')
			{
				navigation('/news');
			}
			else if ([ 'pending', 'reject', 'deactive' ].includes(session?.isActive))
			{
				navigation('/emp');
			}
		};

		useEffect(() =>
		{
			if (Object.keys(session).length === 0)
			{
				navigation('/');
			}
			else
			{
				handleUserNavagation();
			}

			socket?.off('user_actions')?.on('user_actions', (data) =>
			{
				if (data?.action === 'active')
				{
					window.location.reload();
					navigation('/news');
					dispatch(getProfileData({ isActive: data?.action }));
				}
			});
		}, [ socket, session ]);

		return (
			<div className='flexCol fullHeight'>
				<div className='innerMainEmpPenCntr'>
					<div className='flexRow empPendHeader brdrBSM alignCntr respdngHSM  whiteBg'>
						<div className='flexMinWidthRow alignCntr'>
							<div className='showMobLogon'>
								<div className='flexAutoRow alignCntr pdngXS'>
									<img src='/images/logos/In_logo.svg' alt='inLynk-logo' className='authLogo'/>
								</div>
							</div>
							<div className='flexAutoRow alignCntr pdngRSM'>
								<CompanyDropdown userData={session} showCompanyName />
							</div>
						</div>

					</div>
					<WrappedComponent />
				</div>

			</div>
		);
	};
};

export default EmployeePendingHoc;
